export default {
    header: {
        telefone: "电话",
        signIn: "登录",
        register: "注册",
        becomeExpert: "注册您的公司",
        dashboard: "控制面板",

        sidebar: {
            tuktuk: {
                title: "嘟嘟车",
                subtitle: "嘟嘟车预订",
                menu: {
                    grid: "嘟嘟车列表",
                },
            },
            about: {
                title: "关于",
                subtitle: "关于",
                menu: {
                    aboutUs: "关于我们",
                    testimonials: "客户评价",
                    faq: "常见问题",
                    contact: "联系我们",
                    terms: "条款和条件",
                    privacy: "隐私政策",
                },
            },
            dashboard: {
                title: "控制面板",
                subtitle: "用户面板",
                subtitle2: "代理面板",
                menu: {
                    dashboard: "控制面板",
                    myBookings: "我的预订",
                    reviews: "评论",
                    support: "支持",
                    wishlist: "愿望清单",
                    wallet: "钱包",
                    profileSettings: "个人资料设置",
                    notifications: "通知",
                    myProfile: "我的资料",
                    settings: "设置",
                    dashboard2: "控制面板",
                    bookings: "预订",
                    enquiries: "咨询",
                    earnings: "收益",
                    reviews2: "评论",
                    settings2: "设置",
                },
            },
            social: {
                title: "社交网络",
                subtitle: "帖子动态",
                menu: {
                    feed: "动态",
                    myProfilePage: "我的个人主页",
                    explore: "探索",
                },
            },
        },
    },

    common: {
        welcome: "欢迎，{{name}}！",
    },

    home: {
        hero: {
            title: "更接近梦想：",
            title2: "您的旅行必需品正在等待",
            title3: "您",
            subtitle: "您的一站式旅行平台，帮助您庆祝并铭记每一次旅程的精彩瞬间。",
            tukTuk: "嘟嘟车",
        },
        searchBy: {
            titlePrefix: "最新",
            titleSuffix: "套餐",
            subtitle:
                "发现 Portugalwaytour 最新添加的旅行套餐，探索独特的旅行机会，精心挑选的体验将为您带来难忘的冒险、新的目的地和独家旅程。",
            noPackages: "未找到最新套餐。",
            hasDiferencial: "特色套餐",
            noReviews: "暂无评论",
            viewAll: "查看所有套餐",
        },
        sectionBenefit: {
            titlePrefix: "我们的",
            titleHighlight: "优势",
            titleSuffix: "与主要亮点",
            subtitle:
                "Portugalway 是一家专注于梦想目的地的旅游运营商，为旅行者提供多种独特的好处。",
            benefits: [
                {
                    title: "真实体验",
                    description:
                        "远离传统旅游，探索真实的葡萄牙！我们的行程让您深入了解当地文化、美食和隐藏的宝藏。",
                },
                {
                    title: "个性化旅游套餐",
                    description:
                        "打造属于您的定制旅行！选择您的体验，我们将安排住宿、交通和活动，为您提供难忘的旅程。",
                },
                {
                    title: "舒适与安全",
                    description:
                        "我们关注每个细节：舒适的交通、精挑细选的住宿和专业导游，确保旅途安心无忧。",
                },
                {
                    title: "专属服务",
                    description:
                        "从第一次联系到旅程结束，我们提供个性化支持，葡萄牙语和英语双语团队随时为您服务，响应迅速、贴心周到。",
                },
            ],
        },
        exploreCities: {
            title: "按城市探索",
            subtitle: "在迷人的目的地中发现独特的体验",
        },
        placeSection: {
            titlePrefix: "热门",
            titleHighlight: "套餐",
            subtitle:
                "探索我们最受欢迎的旅行套餐，这些套餐因高评分、好评和频繁预订而脱颖而出。在这里找到您的下一次难忘之旅。",
            all: "全部",
            hasDiferencial: "特色套餐",
            noReviews: "暂无评论",
            viewAll: "查看所有套餐",
        },
        aboutSection: {
            welcome: "欢迎来到 Portugalwaytour",
            title: "探索地平线之外：发现世界奇观",
            description1: "在 Portugal Way Tour，我们相信旅行会带来改变。我们专注于葡萄牙独特的旅游体验，致力于展示这个国家最精彩的部分——文化、风景、历史和真实性。",
            point1: "提供令人难忘的旅程，兼具舒适、安全与魅力。我们希望每位游客都能深度探索葡萄牙，将传统、自然、美食与真诚的待客之道完美结合。",
            point2: "成为葡萄牙旅游行业中高品质与信任的典范，让来自世界各地的游客将我们视为专业与魅力的代名词。",
            learnMore: "了解更多",
            reviews: "{{count}}+ 条评价"
        },
        aboutCounters: [
            { label: "全球目的地", icon: "isax-global5", colorClass: "text-teal" },
            { label: "完成预订", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "全球客户", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "注册供应商", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "热门服务",
            popularSubtitle: "探索旅客最喜爱、评分最高、预订最频繁的服务。",
            serviceName: "嘟嘟车司机",
            loading: "加载中...",
            reservationsSingular: "预订",
            reservationsPlural: "预订",
            viewProfile: "查看资料",
            viewAll: "查看全部",
        },
        driverModal: {
            loading: "加载中...",
            description: "描述",
            languages: "语言",
            vehicle: "车辆",
            seats: "座位",
            averageRating: "平均评分",
            reviews: "评论",
            packages: "套餐",
            noReviews: "暂无评论",
            noPackages: "此司机暂无注册套餐"
        },
        testimonialSection: {
            title: "我们的{{highlight}}怎么说",
            highlight: "用户",
            subtitle: "看看旅行者们对他们体验的评价。",
            loading: "加载评论中...",
            noReviews: "暂无评论。",
            noComment: "用户未留下评论。",
            viewPackage: "查看套餐详情"
        },
        updateSection: {
            faq: {
                title: "{{highlight}}问题",
                highlight: "常见",
                subtitle: "Portugalway 是一家专注于梦想目的地的旅游运营商，为旅行者提供多种好处。",
                questions: [
                    {
                        question: "如何预订旅游？",
                        answer: "您可以通过我们的网站直接预订，或通过电子邮件或电话与我们联系。确认行程后，我们会提供报价、确认酒店和服务，并根据政策收取付款。"
                    },
                    {
                        question: "可以自定义行程吗？",
                        answer: "当然可以！我们的所有行程都很灵活。您可以选择想去的地方、停留时间和住宿类型，我们将根据您的喜好制定个性化行程。"
                    },
                    {
                        question: "导游会说哪些语言？",
                        answer: "我们的导游会讲葡萄牙语、英语，部分行程可提供其他语言服务。请在预订时说明您的语言偏好。"
                    },
                    {
                        question: "取消政策如何？",
                        answer: "取消政策取决于行程、提前时间和供应商。在预订时，我们会提供完整条款。请在确认前仔细阅读。"
                    },
                    {
                        question: "接受哪些付款方式？",
                        answer: "我们接受国际银行转账、信用卡支付，部分情况下还接受其他付款方式。"
                    }
                ],
                contactUsText: "如果您未在常见问题中找到答案，请联系我们。我们将尽快回复！",
                contactButton: "联系我们",
            },
            support: {
                items: [
                    "定制行程",
                    "完整规划",
                    "专家指导",
                    "本地体验",
                    "客户支持",
                    "可持续发展努力",
                    "多区域服务"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "页面",
            settings: "设置",
            profile: "个人资料",
            social: "社交网络",
        },
        company: {
            title: "公司",
            about: "关于我们",
            testimonials: "客户评价",
            faq: "常见问题",
        },
        support: {
            title: "支持",
            contact: "联系我们",
            privacy: "隐私政策",
            terms: "条款与条件",
            chat: "在线聊天支持",
        },
        services: {
            title: "服务",
            tuktuk: "嘟嘟车",
            winery: "酒庄",
            restaurant: "餐厅",
            car: "汽车",
            hippotrip: "海马旅行",
            bike: "自行车",
        },
        bottom: {
            copyright: "版权所有 © 2025。保留所有权利，",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "访问您的账户",
            subtitle: "输入您的邮箱以登录或创建账户",
            emailLabel: "邮箱",
            emailPlaceholder: "请输入您的邮箱",
            sendTestCode: "发送测试代码",
            sendEmailCode: "通过邮箱发送代码",
            codeLabel: "验证码",
            codePlaceholder: "请输入验证码",
            verifyAndLogin: "验证并登录",
            testCodeSuccess: "测试代码 '123456' 已生成，请使用该代码登录。",
            testCodeError: "生成测试代码时出错。",
            emailSent: "验证码已发送到您的邮箱！",
            emailError: "发送验证码时出错。",
            loginSuccess: "登录成功！",
            invalidCode: "无效或已过期的验证码。",
            or: "或者",
            google: "谷歌",
            facebook: "脸书",
            reminderTitle: "完善您的个人资料",
            reminderText: "不要忘记完善您的个人资料，以便享受平台的所有功能！",
            gotIt: "知道了",
        },
    },

    companyRegisterModal: {
        title: "公司注册",
        step1: "请输入您的个人邮箱以创建公司管理员账户。您将使用该账户管理公司的资料。",
        step2: "我们已向您的邮箱发送验证码，请在下方输入以验证您的身份。",
        step3: "现在请填写您的公司信息。公司的邮箱应为企业联系方式（例如：info@company.com）。",

        personalEmail: "您的个人邮箱",
        sendTestCode: "发送测试代码",
        sendEmailCode: "通过邮箱发送验证码",

        verificationCode: "验证码",
        verifyCode: "验证验证码",

        companyEmail: "公司邮箱",
        companyName: "公司名称",
        nif: "税号",
        nib: "银行账户号",
        permanentCertificate: "永久证书编号",
        phone: "电话",
        street: "街道",
        city: "城市",
        postalCode: "邮政编码",
        country: "国家",
        companyDescription: "公司简介",
        servicesProvided: "提供的服务",

        contractTitle: "公司合同",
        acceptContract: "我接受公司的合同",
        finishRegistration: "完成注册",

        messages: {
            "Test code sent successfully. Use '123456'.": "测试代码已发送成功，请使用 '123456'。",
            "Verification email sent successfully.": "验证邮件发送成功。",
            "Verification successful.": "验证成功。",
            "Company registered and contract accepted successfully!": "公司注册成功，合同已接受！",
            testStepMessage: "测试代码已发送成功，请使用 '123456'。",
            emailStepMessage: "验证邮件已发送到您的邮箱，请在下方输入。"
        },

        errors: {
            "Failed to send the verification code.": "发送验证码失败。",
            "Invalid or expired code.": "验证码无效或已过期。",
            "Please fill all required fields.": "请填写所有必填项。",
            "You must accept the contract to register the company.": "您必须接受合同才能注册公司。",
            "You must be logged in to register the company.": "您必须登录才能注册公司。",
            "Failed to register the company or accept the contract.": "注册公司或接受合同失败。"
        }
    },

    chooseUsSection: {
        title: "为什么选择我们？",
        cards: [
            {
                title: "便利性",
                description: "通过一个平台规划您的整个行程，节省时间和精力。无需在不同网站间切换。"
            },
            {
                title: "最佳价格保证",
                description: "我们与可靠的旅行伙伴合作，为您提供最佳优惠，无论是预订航班、酒店还是租车。"
            },
            {
                title: "客户支持",
                description: "我们的专属支持团队全天候为您服务，确保您的行程顺利无忧。"
            },
            {
                title: "个性化旅行体验",
                description: "无论您是商务出行、家庭度假还是独自冒险，我们都提供满足各种需求的旅行方案。"
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "首页",
            pages: "页面",
            contactUs: "联系"
        },
        title: "联系我们的专属支持团队",
        description: "我们的团队随时为您提供帮助。您的满意是我们的首要任务。",
        info: [
            {
                label: "邮箱地址",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "电话号码",
                value: "INSERT NUMBER"
            },
            {
                label: "我们的地址",
                value: "INSERT RUA , 阿尔马达 - 葡萄牙"
            }
        ],
        supportCard: {
            title: "需要帮助吗？",
            textLoggedOut: "要联系我们的支持团队并提交工单，您需要创建账户或登录。之后，您将可以在支持面板中跟踪和管理请求。",
            textLoggedIn: "您已登录！现在可以直接在面板中提交新的支持工单或跟踪已有工单。",
            btnLoggedOut: "创建账户 / 登录",
            btnLoggedIn: "在面板中提交工单"
        }
    },

    sidebar: {
        main: "主菜单",
        dashboard: "面板",
        myBookings: "我的预订",
        myReviews: "我的评价",
        wishlist: "心愿单",
        support: "支持",
        finance: "财务",
        wallet: "钱包",
        payments: "付款",
        account: "账户",
        myProfile: "我的资料",
        notifications: "通知",
        settings: "设置",
        preferences: "偏好",
        logout: "登出",
    },

    agentSidebar: {
        dashboard: "面板",
        bookings: "预订",
        tukTukBookings: "嘟嘟车预订",
        hotelBookings: "酒店预订",
        carBookings: "汽车预订",
        cruiseBookings: "邮轮预订",
        tourBookings: "旅行预订",
        flightBookings: "航班预订",
        enquiries: "咨询",
        earnings: "收益",
        reviews: "评价",
        support: "支持",
        serviceEnrollment: "服务注册",
        drivers: "司机",
        tukTukVehicles: "嘟嘟车车辆",
        settings: "设置",
        logout: "登出",
    },

    dashboardCards: {
        totalBookings: "已购买套餐总数",
        totalListings: "套餐总数",
        totalEarnings: "总收入",
        totalReviews: "评价总数",
    },

    recentlyadded: {
        titulo: "最近添加",
    },

    BookingsStatistics: {
        titulo: "预订统计",
        loading: "正在加载统计数据...",
        none: "尚未有预订记录。",
    }
};
